module.exports = __webpack_public_path__ + "static/media/Platformbanner@3x.b03ee4e5.png";